import { gql } from '__generated__';

export default gql(`
  mutation ExportRegistrations($input: ExportRegistrationsInput!) {
    exportRegistrations(input: $input) {
      id
      format
    }
  }
`);
